import { showAiCreditsRestrictionPopup } from "../slices/accessControl.slice";

export const CREDIT_BALANCE_EXCEEDED = "credit_balance_exceeded";

// 429 { error: "credit_balance_exceeded", scope: "company", resetsAt: "..." }
export type CreditBalanceExceededBody = {
  error?: string;
  scope?: string | null;
  resetsAt?: string | null;
};

// The body may arrive already parsed (fetchBaseQuery) or as raw text when the
// response is not served as application/json.
const toErrorBody = (data: unknown): CreditBalanceExceededBody | null => {
  let parsed: unknown = data;

  if (typeof parsed === "string") {
    try {
      parsed = JSON.parse(parsed);
    } catch {
      return null;
    }
  }

  return typeof parsed === "object" && parsed !== null
    ? (parsed as CreditBalanceExceededBody)
    : null;
};

/**
 * Returns the parsed body when the response is an AI credit balance rejection,
 * otherwise null.
 */
export const getCreditBalanceExceeded = (
  status: number | string | undefined,
  data: unknown
): CreditBalanceExceededBody | null => {
  if (status !== 429) return null;
  const body = toErrorBody(data);
  return body?.error === CREDIT_BALANCE_EXCEEDED ? body : null;
};

export const aiCreditsRestrictionAction = (body: CreditBalanceExceededBody) =>
  showAiCreditsRestrictionPopup({
    scope: body.scope ?? null,
    resetsAt: body.resetsAt ?? null,
  });
